import { render, staticRenderFns } from "./DemoLayout.vue?vue&type=template&id=52112d96"
import script from "./DemoLayout.vue?vue&type=script&lang=js"
export * from "./DemoLayout.vue?vue&type=script&lang=js"
import style0 from "./DemoLayout.vue?vue&type=style&index=0&id=52112d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports